module.exports = __webpack_public_path__ + "img/sms-edit.dc1477e2.svg";